import Utils from '../../services/utils';

export const personTypesValueLabelList = [
  { label: 'Persona Jurídica y asimiladas', value: '1' },
  { label: 'Persona Natural y asimiladas', value: '2' }
];

export const personTypesLabelsObject = Utils.valueLabelListToLabelsObject(personTypesValueLabelList);
